import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'




// DELETE A BRANCH
const submit = (id) => client.delete(`branch/${id}`);
export const useDeleteBranch = (id) => useMutation(['deleteBranch',id],() => submit(id))